import { render, staticRenderFns } from "./page-agv-customer-orders-list.vue?vue&type=template&id=d2e9eaf2&scoped=true&lang=pug&"
import script from "./page-agv-customer-orders-list.vue?vue&type=script&lang=js&"
export * from "./page-agv-customer-orders-list.vue?vue&type=script&lang=js&"
import style0 from "./page-agv-customer-orders-list.vue?vue&type=style&index=0&id=d2e9eaf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e9eaf2",
  null
  
)

export default component.exports